<div class="info-page">
  <header class="info-hero">
    <p class="info-kicker">Say hello</p>
    <h1 class="info-heading">Contact Us</h1>
    <p class="info-sub">Send feedback, questions, or a room-specific inquiry.</p>
  </header>

  <div class="contact-layout">
    <aside class="info-card contact-aside">
      <h2 class="info-block-title">
        <span class="info-icon info-icon--gold">✦</span>
        We’re listening
      </h2>
      <p>Tell us about a room, a seat, a shipment, or anything else. We read every message.</p>
      <ul class="contact-points">
        <li>Pick the webinar room it relates to</li>
        <li>Choose an inquiry type</li>
        <li>Leave at least 50 characters so we can help</li>
      </ul>
    </aside>

    <article class="info-panel contact-panel">
      <h2 class="info-block-title">
        <span class="info-icon info-icon--coral">&#64;</span>
        Submit Your Feedback
      </h2>
      <form [formGroup]="form" class="contact-form" autocomplete="off">
        <mat-form-field class="clsGapping" appearance="outline">
          <mat-label>Webinar Room</mat-label>
          <mat-select formControlName="webinarRoom">
            <mat-option *ngFor="let Room of webinarRooms" [value]="Room.roomId">
              {{ Room.roomName }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="form.controls['webinarRoom'].invalid">Please select webinar room</mat-error>
        </mat-form-field>

        <div class="contact-inquiry">
          <span class="contact-inquiry-label">*Inquiry Type</span>
          <mat-radio-group formControlName="inquiryType">
            <mat-radio-button *ngFor="let inquiryType of inquiryTypes" [value]="inquiryType.id">
              {{ inquiryType.name }}
            </mat-radio-button>
          </mat-radio-group>
          <mat-error *ngIf="form.controls['inquiryType'].touched && form.controls['inquiryType'].invalid">
            Please select inquiry type
          </mat-error>
        </div>

        <div class="contact-row">
          <mat-form-field class="clsGapping" appearance="outline">
            <mat-label>First Name</mat-label>
            <input matInput type="text" formControlName="firstName" required>
            <mat-error *ngIf="form.controls['firstName'].invalid">Please enter first name</mat-error>
          </mat-form-field>
          <mat-form-field class="clsGapping" appearance="outline">
            <mat-label>Last Name</mat-label>
            <input matInput type="text" formControlName="lastName" required>
            <mat-error *ngIf="form.controls['lastName'].invalid">Please enter last name</mat-error>
          </mat-form-field>
        </div>

        <div class="contact-row">
          <mat-form-field class="clsGapping" appearance="outline">
            <mat-label>Email</mat-label>
            <input matInput type="text" formControlName="emailId" required>
            <mat-error *ngIf="form.controls['emailId'].errors != null && form.controls['emailId'].errors?.required">Email id is required</mat-error>
            <mat-error *ngIf="form.controls['emailId'].errors != null && form.controls['emailId'].errors?.email">Please enter valid email id</mat-error>
          </mat-form-field>
          <mat-form-field class="clsGapping" appearance="outline">
            <mat-label>Phone</mat-label>
            <input matInput formControlName="phoneNumber" (keypress)="onlyNumbers($event)">
            <mat-error *ngIf="form.controls['phoneNumber'].errors != null && form.controls['phoneNumber'].errors?.required">Please enter phone number</mat-error>
            <mat-error *ngIf="form.controls['phoneNumber'].errors != null && form.controls['phoneNumber'].errors?.pattern">Please enter valid phone number</mat-error>
            <mat-error *ngIf="form.controls['phoneNumber'].hasError('minlength')">Must contain minimum 8 numbers.</mat-error>
          </mat-form-field>
        </div>

        <mat-form-field class="clsGapping contact-comments" appearance="outline">
          <mat-label>Comments</mat-label>
          <textarea matInput formControlName="freeText" required rows="5"></textarea>
          <mat-error *ngIf="form.controls['freeText'].hasError('required')">Please enter comments</mat-error>
          <mat-error *ngIf="form.controls['freeText'].hasError('minlength')">Comments must contain at least 50 characters.</mat-error>
        </mat-form-field>

        <button type="button" class="info-cta" (click)="Save()" [disabled]="!form.valid">
          Save Details
        </button>
      </form>
    </article>
  </div>
</div>
